import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-310d0962")

_pushScopeId("data-v-310d0962")
const _hoisted_1 = { class: "auth-layout" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text-right bg-primary" }, [
  /*#__PURE__*/_createVNode("a", {
    target: "_blank",
    href: "https://deskv2.satstreet.com/auth/login",
    class: "text-white mx-2"
  }, " Try the new version ")
], -1)
const _hoisted_3 = { style: {"position":"relative","height":"84%","overflow-y":"auto"} }
const _hoisted_4 = { class: "site-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AuthNavbar = _resolveComponent("AuthNavbar")
  const _component_SiteContent = _resolveComponent("SiteContent")
  const _component_SiteFooter = _resolveComponent("SiteFooter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.showNavbar)
      ? (_openBlock(), _createBlock(_component_AuthNavbar, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_SiteContent)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_SiteFooter)
    ])
  ]))
})